// extracted by mini-css-extract-plugin
export default {"table__container":"styles_table__container__sLdr-","pagination__wrapper":"styles_pagination__wrapper__SWVyK","pagination__container":"styles_pagination__container__DvFMa"};